import { Spinner } from '@/components/Spinner';
import { EditorPickForm } from './form/EditorsPickForm';
import useGetEditorsPickDetail from './hooks/useGetEditorsPickDetails';

const UpdateEditorPickFormContainer = ({ editorId }: { editorId?: string }) => {
  const { editorsPickDetail, isLoading } = useGetEditorsPickDetail(editorId || '');

  const defaultValues = {
    clubId: editorsPickDetail?.[0].clubId ?? '',
    location: editorsPickDetail?.[0].locationId ?? '',
    description: editorsPickDetail?.[0].description ?? '',
    tags: (editorsPickDetail?.[0].tags ?? []).map((text, index) => ({
      id: String(index),
      text,
      className: '',
    })),
  };

  if (isLoading) return <Spinner />;
  return <EditorPickForm mode="update" defaultValues={defaultValues} editorId={editorId ?? ''} />;
};

export default UpdateEditorPickFormContainer;
